import { createSlice } from '@reduxjs/toolkit';

import { sqlExecutor } from '@/integrations/index.api';

import { createAsyncThunk } from '../create-async-thunk';

type TInitialState = {
  response: any[];
  isLoading: boolean;
};

const initialState: TInitialState = {
  response: [],
  isLoading: false
};

export const getExecutorSql = createAsyncThunk(
  'admin/executorSql',
  async (data: { query: string }) => {
    return sqlExecutor.executeSQL(data);
  }
);

export const adminExecutorSqlSlice = createSlice({
  name: 'admin/executor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExecutorSql.pending, (state) => {
        state.isLoading = true;
        state.response = [];
      })
      .addCase(getExecutorSql.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(getExecutorSql.rejected, (state) => {
        state.isLoading = false;
      });
  }
});
